module.exports = __webpack_public_path__ + "static/contact-c7cab9048c23d6e767b5420d1e684070.png";